<template>
  <div :class="mainClass">
    <div
      @click="switchMode"
      :class="{
        'mode-switch': true,
        bike: $store.state.mode === 'bike',
        foot: $store.state.mode === 'foot'
      }"
    >
      <div class="controls">
        <div class="bike-switch single-switch">
          <img src="../assets/bici.svg" />
          <span>Bici</span>
        </div>
        <div class="foot-switch single-switch">
          <span>A piedi</span>
          <img src="../assets/piedi.svg" />
        </div>
      </div>
      <div class="mode-active"></div>
    </div>

    <div class="circle-button marketplace" @click="goToMarketplace">
      <img src="../assets/store.svg" />
      <span>
        <img src="../assets/indietro.svg" />Torna indietro
      </span>
    </div>
    <div class="circle-button segnala" @click="goToSegnala">
      <img src="../assets/segnala.svg" />
      <span>
        <img src="../assets/indietro.svg" />Torna indietro
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "BottomBar",
  computed: {
    mainClass: function() {
      let c = "bottom-bar ";
      c += this.$route.meta.bottomLayout;
      return c;
    }
  },
  methods: {
    switchMode() {
      if (
        ["marketplace", "segnala"].indexOf(this.$route.meta.bottomLayout) > -1
      ) {
        this.$router.push({
          name: "Home"
        });
      } else {
        this.$store.commit(
          "switchMode",
          this.$store.state.mode === "foot" ? "bike" : "foot"
        );
      }
    },
    goToMarketplace() {
      if (this.$route.meta.bottomLayout == "marketplace") {
        if (this.$route.name == "Prodotto") {
          this.$router.go(-1);
        } else {
          this.$router.push({
            name: "Home"
          });
        }
      } else {
        this.$router.push({
          name: "Marketplace"
        });
      }
    },
    goToSegnala() {
      if (this.$route.meta.bottomLayout == "segnala") {
        this.$router.push({
          name: "Home"
        });
      } else {
        this.$router.push({
          name: "Segnala"
        });
      }
    }
  },
  watch: {
    $route() {
      console.log(this.$route);
    }
  },
  data: () => {
    return {};
  },
  mounted() {
    console.log(this.$route);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.bottom-bar {
  position: relative;
  bottom: 0;
  left: 0;
  right: 0;
  background: #f5f5f5;
  // height: 90px;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row no-wrap;
  align-items: center;
  justify-content: space-between;
  padding: 4vw;
}

.foot .bike-switch span {
  display: none;
}
.bike .foot-switch span {
  display: none;
}
.single-switch {
  display: flex;
  align-items: center;
  span {
    color: #fff;
    font-weight: bold;
    margin-left: 20px;
    margin-right: 20px;
    white-space: nowrap;
  }
}

.mode-switch {
  height: 50px;
  background: #d5d5d5;
  border-radius: 25px;
  width: 215px;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;

  transition: all 300ms;
  border-radius: 15vw;
  width: 54vw;
  height: 14vw;
}
.controls {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex: 1;
}
.foot-switch {
  margin-left: auto;
}

.mode-active {
  position: absolute;
  width: 148px;
  height: 50px;
  left: 0;
  top: 0;

  background: #ebb28d;
  border-radius: 74px;
  transition: all 300ms;
  max-width: 100%;

  width: 34vw;
  height: 14vw;
  border-radius: 15vw;
}

.foot .mode-active {
  left: 20vw;
  background: #8ab2cf;
}
.controls {
  position: relative;
  z-index: 2;
}

.circle-button {
  width: 50px;
  height: 50px;
  background: #fff;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05);
  transition: all 300ms;
  overflow: hidden;
  span {
    display: none;
    white-space: nowrap;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    font-weight: bold;
    img {
      margin-right: 10px;
    }
  }

  width: 14vw;
  height: 14vw;
}

.marketplace .mode-switch,
.segnala .mode-switch {
  overflow: hidden;
  width: 14vw;
  padding-left: 10px;
  padding-right: 10px;
}

.marketplace .marketplace {
  width: 215px;
  > img {
    display: none;
  }
  > span {
    display: flex;
  }
}

.segnala .segnala {
  width: 215px;
  > img {
    display: none;
  }
  > span {
    display: flex;
  }
}
</style>
